const es = {
  "store": {
    "menu": {
      "catalogs": "Catálogos",
      "products": "Productos",
      "contact": "Contacto",
      "aboutUs": "Sobre nosotros",
      "termsPolicies": "Política de condiciones",
      "storeTimings": "Horarios de la tienda",
      "paymentMethod": "Métodos de pago",
      "online": "En línea",
      "cash": "Contrareembolso",
      "contactUs": "Contáctenos",
      "followUsOn": "Siga con nosotros",
      "shop": "Tienda",
      "payments": "Pagos",
      "shipping": "Envío",
      "address": "Dirección",
      "myAccount": "Mi cuenta",
      "orders": "Pedidos",
      "messages": "Mensajes",
      "login": "Acceso",
      "logout": "Cerrar sesión",
      "information": "Información",
      "termsPrivacy": "Términos y política de privacidad",
      "additionalCharges": "Cargos adicionales",
      "shopPolicies": "Políticas de la tienda",
      "collections": "Colecciones",
      "home": "Casa"
    },
    "headings": {
      "featuredProducts": "Productos Destacados",
      "featuredCollections": "Colecciones destacadas",
      "contactUs": "Contáctenos",
      "followUs": "Siga con nosotros",
      "paymentPartners": "Nuestros socios de pago",
      "storeInformation": "Almacenar información",
      "seamlessPayments": "Pagos sin problemas",
      "fastShipping": "Envío rápido",
      "orderTracking": "Rastreo de orden",
      "copyRight": "Derechos de autor",
      "collections": "COLECCIONES",
      "popularCategories": "CATEGORÍAS POPULARES",
      "viewAll": "Ver todo",
      "productDetails": "Detalles de producto",
      "productDescription": "Descripción del producto",
      "addCustomization": "Añadir personalización",
      "customization": "personalización",
      "customizationText": "Texto de personalización",
      "enterCustomizationText": "Introducir texto de personalización",
      "youMayAlsoLike": "También te puede interesar",
      "estimatedDeliveryTime": "Tiempo de entrega estimado",
      "extraChargesMayApply": "Se pueden aplicar cargos adicionales",
      "typeSomethingToSearch": "Escriba algo para buscar",
      "weCantFindAnyItemMatchingYourSearch": "No podemos encontrar ningún artículo que coincida con su búsqueda",
      "noResultsFound": "No se han encontrado resultados",
      "noConversation": "Parece que aún no has iniciado ninguna conversación.",
      "noMessage": "No hay mensajes todavía",
      "typeYourMesssage": "Escribe tu mensaje...",
      "noSavedAddress": "¡No tienes ninguna dirección guardada!",
      "addNewAddress": "AGREGAR NUEVA DIRECCIÓN",
      "myAddress": "Mi dirección",
      "selectAddress": "Seleccionar dirección",
      "enterLocation": "Ingrese la ubicación",
      "selectNearbyLocation": "Seleccionar ubicación cercana",
      "orderConfirmed": "orden confirmada",
      "thanksForOrder": "Gracias por tu orden",
      "orderSuccess": "Tu pedido ha sido realizado con éxito",
      "orderId": "Su ID de pedido",
      "trackOrder": "Orden de pista",
      "backToHome": "De vuelta a casa",
      "peopleAlso": "La gente también compró esto",
      "modeOfPayment": "Modo de pago",
      "clearHistory": "Borrar historial",
      "bestSellers": "LOS MÁS VENDIDOS",
      "thisJustIn": "ESTO ACABA DE ENTRAR",
      "shopHoursInformation": "TIENDA HORARIO E INFORMACIÓN",
      "links": "ENLACES",
      "payments": "PAGOS",
      "popular": "POPULAR",
      "categories": "CATEGORIAS"
    },
    "contact": {
      "name": {
        "label": "Nombre",
        "placeholder": "Introduzca su nombre"
      },
      "email": {
        "label": "Identificación de correo",
        "placeholder": "Ingrese su ID de correo electrónico"
      },
      "phone": {
        "label": "Número de teléfono",
        "placeholder": "Ingrese su número telefónico"
      },
      "message": {
        "label": "Mensaje",
        "placeholder": "Escribe tu mensaje aquí"
      }
    },
    "words": {
      "enterQuantity": "Introducir cantidad",
      "maxQuantity": "Cantidad máxima",
      "selectGroup": "Selecciona grupo",
      "madeWith": "hecho con",
      "using": "utilizando",
      "catalogs": "Catálogos",
      "filters": "filtros",
      "customization": "personalización",
      "customizationText": "Texto de personalización",
      "selectColor": "Seleccionar el color",
      "availableSizes": "Tallas disponibles",
      "outOfStock": "Agotado",
      "leftInStock": "Quedaban en almacenaje",
      "only": "Solamente",
      "select": "Seleccione",
      "quantity": "Cantidad",
      "subTotal": "Total parcial",
      "item": "Articulo",
      "searchProducts": "Buscar Productos",
      "chat": "Chat",
      "cart": "Carro",
      "customerTestimonials": "Recomendaciones de clientes",
      "checkout": "VERIFICAR",
      "placeOrder": "REALIZAR PEDIDO",
      "proceedToPay": "PROCEDA A PAGAR",
      "rewards": "Recompensas",
      "deliverHere": "Entrega aquí",
      "completePayment": "EL PAGO COMPLETO",
      "paymentMode": "ELEGIR MODO DE PAGO",
      "reviewOrder": "REVISAR ORDEN",
      "items": "Artículos",
      "shippingModes": "Modos de envío",
      "delivery": "Entrega",
      "selfPickup": "Recogerse",
      "pickupAddress": "Dirección de entrega",
      "contactDetails": "Detalles de contacto",
      "deliveryTo": "Entregar a",
      "addressBook": "Directorio",
      "addNew": "Agregar nuevo",
      "addressForDelivery": "Seleccione la dirección para la entrega",
      "selectedAddress": "Dirección seleccionada",
      "changeAddess": "Cambiar o agregar dirección",
      "orderSummery": "Resumen del pedido",
      "applyCoupon": "Aplicar cupón",
      "couponApplied": "Cupón aplicado",
      "apply": "Aplicar",
      "itemTotal": "Total",
      "discount": "Descuento",
      "billingDetails": "Detalles de facturación",
      "shippingFee": "Gastos de envío",
      "tax": "Impuesto",
      "couponDiscount": "Cupón de descuento",
      "amountToPay": "Monto a pagar",
      "back": "Atrás",
      "yourAddress": "Su dirección",
      "viewBilling": "Ver detalles de facturación",
      "placeOrderPay": "Realizar pedido y pagar",
      "delete": "ELIMINAR",
      "cancel": "Cancelar",
      "enterCode": "Introduce el código de cupón",
      "paymentFee": "Cuota de pago",
      "privacyPolicy": "Política de privacidad",
      "termsConditions": "Términos y condiciones",
      "additionalCharges": "Cargos adicionales",
      "directPayments": "Pagos Directos",
      "confirmPayment": "CONFIRMAR PAGO",
      "payVia": "Pagar a través de",
      "error": "error",
      "sort": "Clasificar",
      "pleasePay": "Por favor pague",
      "inAdvance": "por adelantado",
      "makePayment": "HACER EL PAGO",
      "advancePayment": "Pago por adelantado",
      "paymentConfirmedAmount": "Importe del pago confirmado",
      "totalPayable": "Total a pagar",
      "confirmedPayment": "Pago confirmado",
      "paymentDueInfo": "Ignorar si ya se pagó, esto se actualizará una vez que el vendedor confirme el pago",
      "viewCart": "VER CARRITO",
      "hello": "Hola",
      "productName": "nombre del producto",
      "price": "Precio",
      "writeReview": "Escribe una reseña",
      "userName": "Nombre de usuario",
      "emailIdOptional": "ID de correo electrónico (opcional)",
      "digitalShipping": "Envíos digitales",
      "total": "Total",
      "payment": "Pago",
      "addNewAddress": "Agregar nueva dirección"
    },
    "snackBar": {
      "updatedAddressSuccessful": "Dirección actualizada con éxito",
      "addedNewAddressSuccessful": "Nueva dirección agregada con éxito"
    },
    "alerts": {
      "contactDetails": "Por favor complete los datos de contacto",
      "invalidCoupon": "Código de cupón inválido",
      "storeTime": "Verifique los horarios de la tienda en la descripción de la tienda e intente nuevamente más tarde.",
      "noOrders": "¡Aún no has agregado ningún artículo a tu carrito!",
      "preferredAddress": "Seleccione su dirección de envío preferida",
      "noAddressSaved": "¡Aún no tienes ninguna dirección guardada!",
      "deleteCart": "¡Eep! ¿Está seguro de que desea eliminar este artículo de su carrito?",
      "notAvailableforCoupon": "No disponible para el cupón aplicado",
      "uploadScreenshot": "Cargue la captura de pantalla del pago",
      "noTncs": " Esta tienda no ha establecido ninguna Política de Privacidad.",
      "iFoundThis": "Encontré este producto realmente increíble de",
      "checkOutHere": "Echa un vistazo aquí"
    },
    "form": {
      "enter": "Ingresar",
      "fullName": "Nombre completo",
      "enterName": "Ingrese su nombre",
      "phoneNumber": "Número de teléfono",
      "enterPhone": "Introduzca el número de teléfono",
      "alternativeNumber": "Número alternativo",
      "enterAlternativePhone": "Ingrese un número de teléfono alternativo",
      "pincode": "Código PIN",
      "postalcode": "Código postal",
      "zipcode": "Código postal",
      "enterPincode": "Ingrese el código PIN",
      "country": "País",
      "enterCountry": "Introducir país",
      "state": "Expresar",
      "enterState": "Ingresar estado",
      "enterCity": "Ingresar ciudad",
      "city": "Ciudad",
      "doorno": "Número de puerta",
      "buildingName": "Nombre del edificio",
      "text": "Texto",
      "area": "Área",
      "lacality": "Localidad",
      "street": "Calle",
      "landmark": "Punto de referencia",
      "optional": "Opcional",
      "enterLandmark": "Introducir punto de referencia",
      "saveAddressType": "Guardar tipo de dirección",
      "home": "Casa",
      "office": "Oficina",
      "others": "Otros",
      "saveAddressAs": "Guardar dirección como",
      "location": "Localización",
      "searchLocation": "Buscar ubicación",
      "fullAddress": "Dirección completa",
      "addressLine1": "Dirección Línea 1",
      "addressLine2": "Línea de dirección 2",
      "enterFullAddress": "Ingrese la dirección completa",
      "enterEmailID": "Ingrese la identificación de correo electrónico",
      "email": "Identificación de correo",
      "addNew": "Agregar nuevo"
    }
  },
  "common": {
    "more": "Más",
    "shop": "Tienda",
    "viewAll": "Ver todo",
    "browse": "Navegar",
    "browseAll": "Explorar todo",
    "products": "productos",
    "continue": "Continuar"
  },
  "days": {
    "monday": "Lunes",
    "tuesday": "martes",
    "wednesday": "miércoles",
    "thursday": "jueves",
    "friday": "Viernes",
    "saturday": "sábado",
    "sunday": "Domingo"
  },
  "buttons": {
    "submit": "Entregar",
    "add": "Agregar",
    "clearFilters": "Borrar filtros",
    "apply": "Aplicar",
    "updateCart": "Actualización de la compra",
    "addToCart": "Añadir al carrito",
    "buyNow": "COMPRA AHORA",
    "yes": "Sí",
    "no": "No",
    "checkout": "Verificar",
    "loadMore": "Carga más",
    "saveAndProceed": "Guardar y continuar",
    "okay": "DE ACUERDO",
    "soldOut": "AGOTADO",
    "soldOut1": "Agotado",
    "addToBag": "Agregar a la bolsa",
    "viewAll": "Ver todo"
  },
  "orders": {
    "myOrders": "Mis ordenes",
    "orderedOn": "pedido el",
    "multiItem": "Artículo múltiple",
    "viewShop": "Ver tienda",
    "viewOrder": "Ver pedido",
    "soldBy": "Vendido por",
    "orderView": "Vista de pedido",
    "orderId": "Solicitar ID",
    "groupOrderId": "ID de pedido de grupo",
    "orderStatus": "Estado del pedido",
    "tackOrder": "Orden de pista",
    "priceDetails": "Detalles del precio",
    "productPrice": "Precio del producto",
    "discount": "Descuento",
    "paymentFee": "Cuota de pago",
    "shippingFee": "Gastos de envío",
    "totalPrice": "Precio total del producto",
    "paymentMode": "Modo de pago",
    "noOrdersYet": "¡Aún no has pedido ningún artículo!",
    "updating": "Procesando pago...",
    "update": "actualizar",
    "shippingOptions": "Opciones de envío",
    "paymentDue": "Fecha de pago",
    "paymentPending": "Pago pendiente de confirmación",
    "extraCharges": "Cargos adicionales de personalización",
    "pickup": "Recoger",
    "address": "Dirección",
    "shipping": "Envío",
    "trackingDetails": "Detalles de seguimiento",
    "trackingStatus": "Estado de seguimiento",
    "ItemList": "Lista de articulos",
    "itemDetails": "detalles del artículo",
    "totalProducts": "Productos totales",
    "totalQuantity": "Cantidad total",
    "viewNote": "Ver nota",
    "paymentDetails": "Detalles del pago",
    "value": "Valor",
    "taxName": "Nombre fiscal",
    "package": "Paquete",
    "totalAmountPaid": "Cantidad total pagada",
    "totalProductDiscount": "Descuento total del producto",
    "totalAmountPayable": "Importe total a pagar",
    "shippingCharges": "Gastos de envío",
    "customizationFee": "Tarifa de personalización",
    "couponDiscount": "Cupón de descuento",
    "paymentGatewayFd": "Descuento de tarifa de pasarela de pago",
    "paymentGatewayFee": "Tarifa de pasarela de pago",
    "refundedAmount": "Importe reembolsado",
    "directPayment": "Pago directo",
    "paymentScreenshot": "Captura de pantalla de pago",
    "qty": "Cantidad",
    "colors": "Colores",
    "statusHistory": "Historial de estado",
    "status": "Estado",
    "dateTime": "Fecha y hora",
    "updateStatusNote": "Actualizar nota de estado",
    "customerNote": "Nota del cliente",
    "your": "Su",
    "details": "Detalles",
    "mode": "Modo",
    "amount": "Monto",
    "paymentDate": "Fecha de pago",
    "rateThisProduct": "Cómo le gustaría evaluar este producto ?",
    "reviewTitle": "Ingrese el título de la revisión",
    "reviewPlaceHolder": "Dale a tu reseña un encabezado nítido",
    "reviewProductHere": "Revisa el producto aquí",
    "reviewProductHerePlaceHolder": "¡Cuéntanos qué te pareció este producto!",
    "reviewSuccess": "Producto calificado con éxito",
    "submit": "Entregar",
    "ratedAlready": "Ya has valorado este producto",
    "review": "Revisar",
    "rating": "Clasificación",
    "reviews": "Reseñas",
    "ratingReviewHead": "Calificaciones y reseñas",
    "moreReviews": "Más reseñas",
    "terrible": "Terrible",
    "bad": "Malo",
    "alright": "Bien",
    "good": "Bueno",
    "excellent": "Excelente",
    "orderText": "Pedido",
    "paymentText": "Pago",
    "shippingText": "Envío"
  }
}

export default es;